import script from "./procureContractReview.vue?vue&type=script&setup=true&lang=js"
export * from "./procureContractReview.vue?vue&type=script&setup=true&lang=js"

import "./procureContractReview.vue?vue&type=style&index=0&id=779ac7de&lang=less"

const __exports__ = script;

export default __exports__